import { PROFORMA_BLANK_FORM_TEMPLATE } from '@atlassian/jira-item-selector-with-tiles/src/common/constants';
import type { TemplateForm } from '@atlassian/proforma-common-core/form-system-models';
import type { Template } from './types';

export const BLANK_TEMPLATE: Template = {
	group: null,
	subGroup: [],
	name: '',
	lang: null,
	faIcon: { faKey: '' },
	id: PROFORMA_BLANK_FORM_TEMPLATE,
};

export const BLANK_TEMPLATE_FORM: TemplateForm = {
	id: 0,
	updated: '',
	design: {
		settings: {
			templateId: 0,
			name: '',
			submit: {
				lock: false,
				pdf: false,
			},
		},
		layout: [{ version: 1, type: 'doc', content: [] }],
		conditions: {},
		sections: {},
		questions: {},
	},
	state: undefined,
};
